<template>
  <gas-page-shell :breadcrumb="['用户管理', '用户列表']">
  <div class="page-inner">
    <div class="page-head">
      <div class="table-title-group">
        <h3>用户管理</h3>
        <gas-table-toolbar
          :columns="tableColumnDefs"
          :visible-map.sync="tableColumnVisible"
          :selected-count="selectedIds.length"
          :show-batch-delete="tableCanBatchDelete"
          @batch-delete="batchRemove"
        />
      </div>
      <el-button type="primary" size="small" @click="openCreate">新增用户</el-button>
    </div>

    <el-form :inline="true" :model="query" size="small" class="search-form">
      <el-form-item label="关键字">
        <el-input v-model="query.keyword" clearable placeholder="用户名/昵称/邮箱/手机号" @keyup.enter.native="search" />
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="query.status" clearable placeholder="全部">
          <el-option label="正常" value="0" />
          <el-option label="停用" value="1" />
        </el-select>
      </el-form-item>
      <el-form-item label="终端">
        <el-select v-model="query.clientType" clearable placeholder="全部">
          <el-option label="后台" value="admin" />
          <el-option label="App" value="app" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="list" v-loading="loading" border size="small" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="44" align="center" />
      <el-table-column prop="userId" label="ID" width="80" />
      <el-table-column prop="username" label="用户名" min-width="130" />
      <el-table-column prop="nickName" label="昵称" min-width="130" />
      <el-table-column prop="email" label="邮箱" min-width="180" show-overflow-tooltip />
      <el-table-column prop="phone" label="手机号" min-width="130" />
      <el-table-column prop="clientType" label="终端" width="90">
        <template slot-scope="scope">
          <el-tag size="small" :type="scope.row.clientType === 'app' ? 'success' : ''">
            {{ scope.row.clientType === 'app' ? 'App' : '后台' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="90">
        <template slot-scope="scope">
          <gas-status-tag kind="org" :value="scope.row.status" />
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" min-width="160" />
      <el-table-column label="操作" width="170" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="openEdit(scope.row)">修改</el-button>
          <el-button
            type="text"
            size="small"
            class="danger"
            :disabled="scope.row.username === 'admin'"
            @click="remove(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="pager"
      background
      layout="total, sizes, prev, pager, next"
      :total="total"
      :page-size="query.pageSize"
      :current-page="query.pageNum"
      :page-sizes="[10, 20, 50, 100]"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="620px">
      <el-form :model="form" label-width="90px" size="small">
        <el-row :gutter="16">
          <el-col :span="12"><el-form-item label="用户名"><el-input v-model="form.username" :disabled="!!form.userId" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="昵称"><el-input v-model="form.nickName" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="邮箱"><el-input v-model="form.email" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="手机号"><el-input v-model="form.phone" /></el-form-item></el-col>
          <el-col :span="12">
            <el-form-item label="终端">
              <el-select v-model="form.clientType" style="width:100%">
                <el-option label="后台" value="admin" />
                <el-option label="App" value="app" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-radio-group v-model="form.status">
                <el-radio label="0">正常</el-radio>
                <el-radio label="1">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="登录密码">
          <el-input
            v-model="form.password"
            show-password
            :placeholder="form.userId ? '不填写则不修改密码' : '默认 admin123'"
          />
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="form.roleIds" multiple clearable style="width:100%" placeholder="请选择角色">
            <el-option v-for="role in roleOptions" :key="role.roleId" :label="role.roleName" :value="role.roleId" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
  </gas-page-shell>
</template>

<script>
import GasPageShell from '@/components/GasPageShell.vue'
import gasTableEnhance from '@/mixins/gasTableEnhance'
import { userApi, roleApi } from '@/api/system'

const emptyForm = () => ({
  userId: null,
  username: '',
  password: '',
  nickName: '',
  email: '',
  phone: '',
  status: '0',
  clientType: 'admin',
  roleIds: []
})

const emptyQuery = () => ({ pageNum: 1, pageSize: 10, keyword: '', status: '', clientType: '' })

export default {
  components: { GasPageShell },
  mixins: [gasTableEnhance],
  data() {
    return {
      idField: 'userId',
      removeApi: userApi.remove,
      batchRemoveApi: userApi.batchRemove,
      loading: false,
      list: [],
      total: 0,
      query: emptyQuery(),
      dialogVisible: false,
      dialogTitle: '新增用户',
      form: emptyForm(),
      roleOptions: []
    }
  },
  created() {
    this.loadData()
    this.loadRoles()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const res = await userApi.list(this.query)
        const data = res.data || {}
        this.list = data.records || []
        this.total = Number(data.total || 0)
      } finally {
        this.loading = false
      }
    },
    async loadRoles() {
      const res = await roleApi.list({ pageNum: 1, pageSize: 100 })
      this.roleOptions = (res.data && res.data.records) || []
    },
    search() {
      this.query.pageNum = 1
      this.loadData()
    },
    resetSearch() {
      this.query = emptyQuery()
      this.loadData()
    },
    handleSizeChange(size) {
      this.query.pageSize = size
      this.query.pageNum = 1
      this.loadData()
    },
    handleCurrentChange(page) {
      this.query.pageNum = page
      this.loadData()
    },
    openCreate() {
      this.dialogTitle = '新增用户'
      this.form = emptyForm()
      this.dialogVisible = true
    },
    async openEdit(row) {
      this.dialogTitle = '修改用户'
      this.form = { ...emptyForm(), ...row, password: '' }
      const res = await userApi.roleIds(row.userId)
      this.form.roleIds = res.data || []
      this.dialogVisible = true
    },
    async submit() {
      if (!this.form.username) {
        this.$message.warning('请填写用户名')
        return
      }
      if (this.form.userId) await userApi.update(this.cleanPayload(this.form))
      else await userApi.create(this.cleanPayload(this.form))
      this.$message.success('保存成功')
      this.dialogVisible = false
      this.loadData()
    },
    cleanPayload(form) {
      const payload = { ...form }
      if (!payload.password) delete payload.password
      return payload
    },
    async remove(row) {
      await this.$confirm(`确认删除用户 ${row.username}？`, '提示', { type: 'warning' })
      await userApi.remove(row.userId)
      this.$message.success('删除成功')
      this.loadData()
    }
  }
}
</script>

<style scoped>
.page-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; }
.page-head h3 { margin: 0; }
.search-form { margin-bottom: 12px; }
.pager { margin-top: 16px; text-align: right; }
.danger { color: #f56c6c; }
</style>
